import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Mail, Phone, MapPin, Facebook, Instagram, Link2 } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 text-white pt-20 pb-10">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center">
                <Heart className="w-6 h-6 text-white fill-white" />
              </div>
              <div>
                <div className="font-bold text-xl">SRII DUAT</div>
                <div className="text-sm text-purple-300">Wakaf KDU</div>
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed mb-6">
              Kompleks Pendidikan Islam Bersepadu untuk melahirkan generasi berilmu, berakhlak, dan berjiwa ummah. Projek wakaf pendidikan yang berkekalan.
            </p>
            <div className="flex gap-3">
              <a
                href="https://linktr.ee/sriiduat"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linktree-link"
                className="flex items-center gap-2 px-5 h-10 bg-white/10 hover:bg-white/20 rounded-full transition-colors font-medium text-sm"
              >
                <Link2 className="w-5 h-5" />
                <span>Semua Media Sosial</span>
              </a>
              <a
                href="https://linktr.ee/sriiduat"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://linktr.ee/sriiduat"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4">Hubungi Kami</h3>
            <div className="space-y-3">
              <a href="mailto:admin@sriiduat.edu.my" className="flex items-start gap-3 text-gray-300 hover:text-white transition-colors">
                <Mail className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span className="text-sm">admin@sriiduat.edu.my</span>
              </a>
              <a href="tel:+60199742102" className="flex items-start gap-3 text-gray-300 hover:text-white transition-colors">
                <Phone className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span className="text-sm">Admin: 019-974 2102</span>
              </a>
              <a href="tel:+60132102589" className="flex items-start gap-3 text-gray-300 hover:text-white transition-colors">
                <Phone className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span className="text-sm">Guru Besar: 013-210 2589</span>
              </a>
              <div className="flex items-start gap-3 text-gray-300">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5" />
                <span className="text-sm">Lot 1389, Mukim Telok Panglima Garang, Sijangkang, Selangor</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4">Pautan Pantas</h3>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Tentang Projek
                </a>
              </li>
              <li>
                <a href="#impact" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Impak
                </a>
              </li>
              <li>
                <a href="#benefits" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Faedah
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Galeri
                </a>
              </li>
              <li>
                <a href="#faq" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Soalan Lazim
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {currentYear} SRII Darul Ummah Akademi Tarbiyyah & ABIM Selangor. Hak Cipta Terpelihara.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">
                Terma & Syarat
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">
                Dasar Privasi
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;